/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Company } from './Company';
import {
    CompanyFromJSON,
    CompanyFromJSONTyped,
    CompanyToJSON,
    CompanyToJSONTyped,
} from './Company';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * 
 * @export
 * @interface PartnerAttribution
 */
export interface PartnerAttribution {
    /**
     * 
     * @type {number}
     * @memberof PartnerAttribution
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerAttribution
     */
    partnerId: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerAttribution
     */
    category: string;
    /**
     * 
     * @type {Company}
     * @memberof PartnerAttribution
     */
    relatedCompany: Company;
    /**
     * 
     * @type {User}
     * @memberof PartnerAttribution
     */
    salesperson: User;
}

/**
 * Check if a given object implements the PartnerAttribution interface.
 */
export function instanceOfPartnerAttribution(value: object): value is PartnerAttribution {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('partnerId' in value) || value['partnerId'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('relatedCompany' in value) || value['relatedCompany'] === undefined) return false;
    if (!('salesperson' in value) || value['salesperson'] === undefined) return false;
    return true;
}

export function PartnerAttributionFromJSON(json: any): PartnerAttribution {
    return PartnerAttributionFromJSONTyped(json, false);
}

export function PartnerAttributionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerAttribution {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'partnerId': json['partner_id'],
        'category': json['category'],
        'relatedCompany': CompanyFromJSON(json['related_company']),
        'salesperson': UserFromJSON(json['salesperson']),
    };
}

export function PartnerAttributionToJSON(json: any): PartnerAttribution {
    return PartnerAttributionToJSONTyped(json, false);
}

export function PartnerAttributionToJSONTyped(value?: PartnerAttribution | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'partner_id': value['partnerId'],
        'category': value['category'],
        'related_company': CompanyToJSON(value['relatedCompany']),
        'salesperson': UserToJSON(value['salesperson']),
    };
}

